let dirPath = 'static/games/page010_game4';

let configGame = {
  removeInCorrects: true,
  correctBlock: false,
  //autoCheckAllCorrect: true,
  removeAllFromBadTarget: true,
  rulesGame: {
    itemsGarbage: [{ idGroup: 'source', itemsConfig: { block: false, shuffle: false } }],
    itemsConfig: {
      block: true,
      shuffle: true,
    },
    otherProperty: {
      sounds: [{ src: dirPath + '/audio/klik.mp3', id: 'mouseup' }],
    },
    items: [
      {
        idGroup: 't01',
        idItem: 't01',
        itemsConfig: { block: true, shuffle: true },
        items: [
          {
            idGroup: 't01',
            idItem: 't01',
            itemsConfig: { shuffle: true },
            items: [{ idGroup: 'source', idItem: '00', correct: [{ idGroup: 't01', idItem: 't01' }] }],
          },
          {
            idGroup: 't01',
            idItem: 't01',
            itemsConfig: { shuffle: true },
            items: [],
          },
          {
            idGroup: 't01',
            idItem: 't01',
            itemsConfig: { shuffle: true },
            items: [{ idGroup: 'source', idItem: '02', correct: [{ idGroup: 't01', idItem: 't01' }] }],
          },
          {
            idGroup: 't01',
            idItem: 't01',
            itemsConfig: { shuffle: true },
            items: [{ idGroup: 'source', idItem: '03', correct: [{ idGroup: 't01', idItem: 't01' }] }],
          },
          {
            idGroup: 't01',
            idItem: 't01',
            itemsConfig: { shuffle: true },
            items: [{ idGroup: 'source', idItem: '04', correct: [{ idGroup: 't01', idItem: 't01' }] }],
          },
          {
            idGroup: 't01',
            idItem: 't01',
            itemsConfig: { shuffle: true },
            items: [{ idGroup: 'source', idItem: '05', correct: [{ idGroup: 't01', idItem: 't01' }] }],
          },
        ],
      },
      {
        idGroup: 't02',
        idItem: 't02',
        itemsConfig: { block: true, shuffle: true },
        items: [
          {
            idGroup: 't02',
            idItem: 't02',
            itemsConfig: { shuffle: true },
            items: [{ idGroup: 'source', idItem: '01', correct: [{ idGroup: 't02', idItem: 't02' }] }],
          },
          {
            idGroup: 't02',
            idItem: 't02',
            itemsConfig: { shuffle: true },
            items: [{ idGroup: 'source', idItem: '10', correct: [{ idGroup: 't02', idItem: 't02' }] }],
          },
          {
            idGroup: 't02',
            idItem: 't02',
            itemsConfig: { shuffle: true },
            items: [{ idGroup: 'source', idItem: '11', correct: [{ idGroup: 't02', idItem: 't02' }] }],
          },
          {
            idGroup: 't02',
            idItem: 't02',
            itemsConfig: { shuffle: true },
            items: [{ idGroup: 'source', idItem: '12', correct: [{ idGroup: 't02', idItem: 't02' }] }],
          },
        ],
      },
    ],
  },
  layout: {
    groups: [
      {
        idGroup: 't01',
        background: {
          image: { src: dirPath + '/img/21.png' },
        },
        positions: {
          type: 'absolute',
          autoFit: true,
          pos: { x: 950, y: 60, height: 550, width: 888 },
        },
        items: [
          {
            id: 't01',
            positions: { type: 'absolute', pos: { x: 180, y: 250, height: 100, width: 400 } },
            background: {
              color: 'transparent',
              // color: 'rgba(0,0,0,0.3)',
            },
          },
        ],
      },
      {
        idGroup: 't02',
        background: {
          image: { src: dirPath + '/img/20.png' },
        },
        positions: {
          type: 'absolute',
          autoFit: true,
          pos: { x: 0, y: 440, height: 350, width: 310 },
        },
        items: [
          {
            id: 't02',
            positions: { type: 'absolute', pos: { x: 100, y: 130, height: 200, width: 150 } },
            background: {
              color: 'transparent',
            },
            otherProperty: { hideInTarget: true },
          },
        ],
      },
      {
        idGroup: 'source',
        itemsConfig: {
          positions: { pos: { height: 182, width: 183 } },
          background: {
            color: 'transparent',
            text: { size: '27px', textAlign: 'center', textBaseline: 'middle', color: 'black', lineWidth: 380 },
          },
        },
        positions: {
          type: 'absolute',
          autoFit: true,
          fixTab: [
            { x: 0, y: 0 },
            { x: 190, y: 190 },
            { x: 450, y: 30 },
            { x: 460, y: 620 },
            { x: 700, y: 0 },
            { x: 600, y: 400 },
            { x: 400, y: 300 },
            { x: 650, y: 200 },
            { x: 800, y: 500 },
            { x: 933, y: 80 + 600 },
            { x: 1200, y: 620 },
            { x: 1500, y: 650 },
          ],
        },
        items: [
          {
            id: '00',
            background: { image: { src: dirPath + '/img/00.png' } },
          },
          {
            id: '01',
            background: { image: { src: dirPath + '/img/01.png' } },
          },
          {
            id: '02',
            background: { image: { src: dirPath + '/img/02.png' } },
          },
          {
            id: '03',
            background: { image: { src: dirPath + '/img/03.png' } },
          },
          {
            id: '04',
            background: { image: { src: dirPath + '/img/04.png' } },
          },
          {
            id: '05',
            background: { image: { src: dirPath + '/img/05.png' } },
          },
          {
            id: '10',
            background: { image: { src: dirPath + '/img/10.png' } },
          },
          {
            id: '11',
            background: { image: { src: dirPath + '/img/11.png' } },
          },
          {
            id: '12',
            background: { image: { src: dirPath + '/img/12.png' } },
          },
          {
            id: '13',
            background: { image: { src: dirPath + '/img/13.png' } },
          },
          {
            id: '14',
            background: { image: { src: dirPath + '/img/14.png' } },
          },
          {
            id: '15',
            background: { image: { src: dirPath + '/img/15.png' } },
          },
        ],
      },
    ],
  },
};

let dataConfig = {
  mixinEngine: 'dnd',
  realHeight: 850,
  realWidth: 1800,
  configGame: configGame,
  mainImage: {
    imagePath: dirPath + '/img/bcg.png',
    pos: {
      y: 0,
      x: 0,
    },
    width: 1920,
  },
};

export default dataConfig;
